import { render, staticRenderFns } from "./Advocacy.vue?vue&type=template&id=09ea7e1b"
import script from "./Advocacy.vue?vue&type=script&lang=js"
export * from "./Advocacy.vue?vue&type=script&lang=js"
import style0 from "./Advocacy.vue?vue&type=style&index=0&id=09ea7e1b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports